var map = {
	"./Cascada.png": "aacd",
	"./Ciclon.png": "5b9d",
	"./Remolino 50.png": "dcb1",
	"./Silo.png": "f91a",
	"./Torbelliino Lanzado.png": "45ef",
	"./Torbellino Amasador.png": "9de0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35dc";